export { jobEmploymentTypesSk } from './sk';
export { jobEmploymentTypesEn } from './en';
export { jobEmploymentTypesCz } from './cz';

// Helper function to get job employment types by language
import { jobEmploymentTypesSk } from './sk';
import { jobEmploymentTypesEn } from './en';
import { jobEmploymentTypesCz } from './cz';

export function getJobEmploymentTypes(lang: 'sk' | 'en' | 'cz') {
  switch (lang) {
    case 'sk':
      return jobEmploymentTypesSk;
    case 'en':
      return jobEmploymentTypesEn;
    case 'cz':
      return jobEmploymentTypesCz;
    default:
      return jobEmploymentTypesSk; // fallback to Slovak
  }
}
